import React from "react";
import Loginform from "../components/LoginForm";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import { adminLogin, selectAdminAuth } from "../store/slices/adminAuthSlice";

function AdminLoginPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoading } = useSelector(selectAdminAuth);

  const onSubmitHandler = async (values) => {
    const resultAction = await dispatch(adminLogin(values));
    if (adminLogin.fulfilled.match(resultAction)) {
      navigate("/admin/users");
    } else {
      if (resultAction?.payload === 'Not an admin account') {
        toast.error('Only admin accounts can sign in here.');
      } else {
        toast.error(resultAction?.payload || "Login failed");
      }
    }
  };

  return (
    <div>
      <Loginform
        onSubmitHandler={onSubmitHandler}
        hideSignup={true}
        loading={isLoading}
        hideForgotPassword={false}
        forgotPasswordLink={{ pathname: '/forgot-password', search: '?type=admin' }}
      />
    </div>
  );
}

export default AdminLoginPage; 